import { Component, OnInit, Input } from '@angular/core';
import { Guid } from 'guid-typescript';

declare var FileSaver: any;
declare var saveAs: any;
declare var html2canvas: any;
declare var jsPDF: any;
@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {

  @Input() name: string = "Print_" + Guid.create().toString();
  @Input() config: any = {
    Name: this.name,
    Container: "Body",
    FileName: "General",
    ViewPrint: true,
    ViewPrintNewWindow: true,
    ViewScreenshot: true,
    ViewPdfScreenshot: true,
    LabelPrint: "",
    LabelPrintNewWindow: "",
    LabelScreenshot: "",
    LabelPdfScreenshot: "",
  };

  constructor() { }

  ngOnInit() {
    // if (this.config)
    //   this.config = {
    //     Name: this.name,
    //     Container: "Body",
    //     FileName: "General",
    //     ViewPrint: true,
    //     ViewScreenshot: true,
    //     ViewPdfScreenshot: true,
    //     LabelPrint:"",
    //     LabelScreenshot:"",
    //     LabelPdfScreenshot:"",
    //   }
    // else {
    //   this.name = this.config.Name;
    // }
  }

  get IsBody(): boolean {
    return (this.config.Container == "Body" || !this.config.Container || this.config.Container == "body");
  }
  PrintDiv(divName) {

    let newWindow = window.open('', 'PRINT', 'height=720,width=1080');

    newWindow.document.write('<html><head><title>' + document.title + '</title>');
    newWindow.document.write('</head><body >');
    newWindow.document.write('<h1>' + document.title + '</h1>');
    newWindow.document.write(document.getElementById(divName).innerHTML);
    newWindow.document.write('</body></html>');

    newWindow.document.close(); // necessary for IE >= 10
    newWindow.focus(); // necessary for IE >= 10*/

    newWindow.print();
    newWindow.close();

  }

  Print() {
    debugger;
    if (this.IsBody)
      window.print();
    else
      this.PrintDiv(this.config.Container);
  }
  PrintNewWindow() {
    const elementContainer = (this.IsBody) ? document.body : document.getElementById(this.config.Container);
    const w = window.open();
    w.document.write(elementContainer.innerHTML);
    w.print();
    w.close();
  }
  GenerateImageScreenshot() {

    const elementContainer = (this.IsBody) ? document.body : document.getElementById(this.config.Container);

    debugger;
    html2canvas(elementContainer, {
      background: '#FFFFFF'
    }).then((canvas) => {

      if (navigator.userAgent.indexOf("MSIE ") > 0 ||
        navigator.userAgent.match(/Trident.*rv\:11\./)) {
        var blob = canvas.msToBlob();
        window.navigator.msSaveBlob(blob, this.config.FileName + '.png');
      }
      else {


        canvas.toBlob((blob) => {

          saveAs(blob, this.config.FileName + ".png");
        });

      }
    });

  }
  GeneratePdfScreenshot() {
    const elementContainer = (this.IsBody) ? document.body : document.getElementById(this.config.Container);
    debugger;
    html2canvas(elementContainer, {
      background: '#FFFFFF'
    }).then((canvas) => {

      if (navigator.userAgent.indexOf("MSIE ") > 0 ||
        navigator.userAgent.match(/Trident.*rv\:11\./)) {
        var blob = canvas.msToBlob();
        window.navigator.msSaveBlob(blob, this.config.FileName + '.png');
      }
      else {
        var imgData = canvas.toDataURL("image/jpeg");
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth / canvas.width);
        var heightLeft = imgHeight;
        var doc = new jsPDF('p', 'mm');
        var position = 0;

        doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {

          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }



        doc.save(this.config.FileName + ".pdf");

      }
    });


  }
}

